import { Dispatch, SetStateAction, useCallback } from 'react';

interface CheckBoxProps {
  checked: boolean;
  setChecked: (checked: boolean) => void;
}

const CheckBox = ({ checked, setChecked }: CheckBoxProps) => {
  const handleChange = () => {
    setChecked(!checked);
  };

  return (
    <div
      style={{
        width: 14,
        height: 14,
        borderRadius: 4,
        backgroundColor: checked ? '#07d993' : 'transparent',
        border: checked ? 'none' : '1px solid #777986',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
      }}
      onClick={handleChange}
    >
      {checked && <CheckIcon />}
    </div>
  );
};

const CheckIcon = () => {
  return (
    <svg width="10" height="10" viewBox="0 0 14 14" fill="none">
      <path
        d="M10.3198 4.03711C10.5749 3.7873 10.9874 3.78752 11.2426 4.03711C11.4996 4.2888 11.4996 4.6985 11.2426 4.9502L6.12542 9.96289C5.99762 10.0879 5.83043 10.1503 5.66448 10.1504C5.49831 10.1504 5.33051 10.0881 5.20257 9.96289L2.75725 7.56738C2.50029 7.31569 2.50029 6.90599 2.75725 6.6543C3.01245 6.40444 3.42495 6.40438 3.68011 6.6543L5.6635 8.59668L10.3198 4.03711Z"
        fill="white"
        stroke="white"
        strokeWidth="0.3"
      />
    </svg>
  );
};

export default CheckBox;
